import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverTimesheet from './ReportDriverTimesheet'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportDriverTimesheet} />
    </Switch>
)

export default Components
